import Cookie from 'js-cookie';
import { AUTH_COOKIE_PATH } from '../constants';
import t from 'tcomb-form';
import Url from './Url';
import { ONBOARDING_STEPS_MAP } from '../constants';
import { isEmpty } from 'lodash/lang';


export default function isLoggedIn(user=null) {
  let c = Cookie.get(AUTH_COOKIE_PATH);

  if (c && c != undefined) {
    return true;
  }

  return false;
}


/*
 * Converts tcomb Struct to JS FormData object
 */
export function structToFormData(structValue) {
  var formData = new FormData();

  for(const key in structValue) {
    const value = structValue[key];

    if (value == null) {
      continue;
    }


    if(t.form.File.is(value)) {
      formData.append(key, value, value.name);
    }
    else {
      formData.append(key, value);
    }
  }
  return formData;
}

export function objectToFormData(obj) {
  return structToFormData(obj);
}


export function removeOnBoardingStep(flow, step) {
//  Deprecated. See removeFlowStep [MN]
  let nflow = Object.assign(flow)
  const i = flow.indexOf(step)
  if (i !== -1) {
    nflow.splice(i, 1)
  }

  return flow
}


export function getNextOnBoardingStep(user) {
  const url = new Url;
  if(user.depot.flow && user.depot.flow.length > 0) {
    return user.depot.flow[0];
  } else if(user.organizationClaim && user.organizationClaim.approved_on) {
    return `/organizations/${user.organizationClaim.organization}`;
  } else if (url.query && url.query.next) {
    return url.query.next;
  } else {
    return '/my';
  }
}

export function removeFlowStep(flow, step) {
  return removeOnBoardingStep(flow, step)
}

export function getNextFlowStep(user) {
  return getNextOnBoardingStep(user)
}


export function isUrl(url) {
  let res = url.match(/^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i);
  return (res == null) ? false : true;
}


export function isEmail(email) {
  let res = email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i)
  return (res == null) ? false : true;
}


export function isTouchDevice() {
  return 'ontouchstart' in document.documentElement;
}


export function findInBaseStateTree (trees, needle, needlePath = 'id', path = 'name') {
    function findInTree(tree, needle, needlePath, path) {
        if (tree[needlePath] == needle) {
            return tree[path];
        } else {
            for (let child of tree.children) {
                let pathValue = findInTree(child, needle, needlePath, path);
                if (!isEmpty(pathValue)) {
                    return pathValue;
                }
            }
            return null;
        }
    }


    for(let i = 0; i < trees.length; i++) {
        let pathValue = findInTree(trees[i], needle, needlePath, path);
        if (pathValue) {
            return pathValue;
        }
    }
    return null;

}


/* Not used anywhere, just as a reminder */
export function browserIsIdle() {
  let hidden = "hidden";

  // Standards:
  if (hidden in document)
    document.addEventListener("visibilitychange", onchange)
  else if ((hidden = "mozHidden") in document)
    document.addEventListener("mozvisibilitychange", onchange)
  else if ((hidden = "webkitHidden") in document)
    document.addEventListener("webkitvisibilitychange", onchange)
  else if ((hidden = "msHidden") in document)
    document.addEventListener("msvisibilitychange", onchange)
  // IE 9 and lower:
  else if ("onfocusin" in document)
    document.onfocusin = document.onfocusout = onchange
  // All others:
  else
    window.onpageshow = window.onpagehide
    = window.onfocus = window.onblur = onchange

  function onchange (evt) {
    let v = "visible",
        h = "hidden",
        evtMap = {
          focus:v, focusin:v, pageshow:v, blur:h, focusout:h, pagehide:h
        }

    evt = evt || window.event
    if (evt.type in evtMap)
      document.body.className = evtMap[evt.type]
    else
      document.body.className = this[hidden] ? "hidden" : "visible"
  }

  // set the initial state (but only if browser supports the Page Visibility API)
  if( document[hidden] !== undefined )
    onchange({type: document[hidden] ? "blur" : "focus"})
}



// WEBPACK FOOTER //
// ./src/utils/index.js